// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"info_section_infoContainer__3myBX","button":"info_section_button__k0EQa"};